/* eslint-disable no-unneeded-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import SlickSlider from '~/modules/ecommerceCoreUI/components/slickSlider/SlickSlider';
import { mediaSizesMax } from '~/modules/core/utils/cssHelpers/cssMedia';

const SliderWrapper = styled.div`
  .slick-slider {
    :after {
      position: absolute;
      bottom: ${props => props.theme.paddings.xLarge}px;
      right: 0;
      left: 0;
      border-bottom: ${props => props.theme.borders.size.thin}px solid
        ${props => props.theme.borders.color.light};
      content: '';
    }
    .slick-track {
      margin-bottom: 27px !important;
    }
    .slick-list {
      margin: 0 -${props => props.theme.paddings.normal}px;
    }
    .slick-dots {
      margin-bottom: 33px;
      background-color: ${props => props.theme.colors.invertedLabels.important};
      z-index: 1;
    }
    .slick-slide {
      padding: 0 ${props => props.theme.paddings.small}px;
      margin-bottom: 12px;
      > div > div {
        width: 100% !important;
        margin: 0;
        max-width: none;
      }
    }
    .slick-prev {
      left: 14px;
    }
    .slick-next {
      right: 14px;
    }
    .slick-prev,
    .slick-next {
      top: ${props => (props.isVertical ? 47 : 42)}%;
    }
  }
`;
const checkChildrenCount = (children, count) => (children.length <= count ? false : true);
const ItemsCardsSlider = ({ children, isVertical }) => {
  const settings = {
    dots: true,
    arrows: true,
    speed: 500,
    infinite: isVertical ? checkChildrenCount(children, 5) : true,
    slidesToShow: isVertical ? 5 : 1,
    slidesToScroll: isVertical ? 5 : 1,
    responsive: [
      {
        breakpoint: mediaSizesMax.desktop + 20,
        settings: {
          infinite: isVertical ? checkChildrenCount(children, 4) : true,
          slidesToShow: isVertical ? 4 : 1,
          slidesToScroll: isVertical ? 4 : 1,
        },
      },
      {
        breakpoint: mediaSizesMax.smallDesktop - 100,
        settings: {
          infinite: isVertical ? checkChildrenCount(children, 3) : true,
          slidesToShow: isVertical ? 3 : 1,
          slidesToScroll: isVertical ? 3 : 1,
          arrows: false,
        },
      },
      {
        breakpoint: mediaSizesMax.tablet,
        settings: {
          infinite: isVertical ? checkChildrenCount(children, 4) : true,
          slidesToShow: isVertical ? 4 : 1,
          slidesToScroll: isVertical ? 4 : 1,
          arrows: false,
        },
      },
      {
        breakpoint: mediaSizesMax.mobile + 150,
        settings: {
          infinite: isVertical ? checkChildrenCount(children, 3) : true,
          slidesToShow: isVertical ? 3 : 1,
          slidesToScroll: isVertical ? 3 : 1,
          arrows: false,
        },
      },
      {
        breakpoint: mediaSizesMax.xsmall + 200,
        settings: {
          slidesToShow: isVertical ? 2 : 1,
          slidesToScroll: isVertical ? 2 : 1,
          infinite: isVertical ? checkChildrenCount(children, 2) : true,
          arrows: false,
        },
      },
      {
        breakpoint: mediaSizesMax.xsmall - 50,
        settings: {
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
  return (
    <SliderWrapper isVertical={isVertical}>
      <SlickSlider settings={settings}>{children}</SlickSlider>
    </SliderWrapper>
  );
};

ItemsCardsSlider.propTypes = {
  children: PropTypes.node.isRequired,
  isVertical: PropTypes.bool,
};
ItemsCardsSlider.defaultProps = {
  isVertical: true,
};

export default ItemsCardsSlider;
